import SVGIcon from '../SVGIcon';

function LockIcon() {
  return (
    <SVGIcon width="12" height="14" viewBox="0 0 12 14" fill="none">
      <path
        d="M6.00008 0.333496C4.53322 0.333496 3.33341 1.5333 3.33341 3.00016V4.3335H2.16675C1.33975 4.3335 0.666748 5.0065 0.666748 5.8335V12.1668C0.666748 12.9938 1.33975 13.6668 2.16675 13.6668H9.83341C10.6604 13.6668 11.3334 12.9938 11.3334 12.1668V5.8335C11.3334 5.0065 10.6604 4.3335 9.83341 4.3335H8.66675V3.00016C8.66675 1.5333 7.46694 0.333496 6.00008 0.333496ZM6.00008 1.3335C6.92655 1.3335 7.66675 2.07369 7.66675 3.00016V4.3335H4.33341V3.00016C4.33341 2.07369 5.07361 1.3335 6.00008 1.3335ZM6.00008 8.00016C6.55241 8.00016 7.00008 8.44783 7.00008 9.00016C7.00008 9.5525 6.55241 10.0002 6.00008 10.0002C5.44775 10.0002 5.00008 9.5525 5.00008 9.00016C5.00008 8.44783 5.44775 8.00016 6.00008 8.00016Z"
        fill="#696969"
      />
    </SVGIcon>
  );
}

export default LockIcon;
